/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const GiftBox = (props: IconProps) => (
  <Icon {...props}>
    <path
      d="M9.06 0.930003C7.17 0.920003 5.33 2.74 6.17 5H3C2.46957 5 1.96086 5.21072 1.58579 5.58579C1.21071 5.96086 1 6.46957 1 7V9C1 9.26522 1.10536 9.51957 1.29289 9.70711C1.48043 9.89465 1.73478 10 2 10H11H13H22C22.2652 10 22.5196 9.89465 22.7071 9.70711C22.8946 9.51957 23 9.26522 23 9V7C23 6.46957 22.7893 5.96086 22.4142 5.58579C22.0391 5.21072 21.5304 5 21 5H17.83C19 1.73 14.6 -0.579997 12.57 2.24L12 3L11.43 2.22C10.8 1.33 9.93 0.940003 9.06 0.930003ZM9 3C9.89 3 10.34 4.08 9.71 4.71C9.08 5.34 8 4.89 8 4C8 3.73479 8.10536 3.48043 8.29289 3.2929C8.48043 3.10536 8.73478 3 9 3ZM15 3C15.89 3 16.34 4.08 15.71 4.71C15.08 5.34 14 4.89 14 4C14 3.73479 14.1054 3.48043 14.2929 3.2929C14.4804 3.10536 14.7348 3 15 3ZM2 11V19C2 19.5304 2.21071 20.0391 2.58579 20.4142C2.96086 20.7893 3.46957 21 4 21H12H20C20.5304 21 21.0391 20.7893 21.4142 20.4142C21.7893 20.0391 22 19.5304 22 19V11H13H11H2Z"
    />
  </Icon>
);
